<template>
  <svg
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m15 0a15 15 0 1 0 15 15 15 15 0 0 0 -15-15zm10.17 23.75v-.05c-1.21-1.23-1.49-1.49-2.7-2.71-.79-.81-2 .44-1.23 1.24 1.21 1.23 1.49 1.49 2.7 2.71h.05a13.41 13.41 0 0 1 -18.91-18.94l3.42 3.37a.82.82 0 0 0 1.16-1.16l-3.4-3.38a13.41 13.41 0 0 1 18.91 18.92z"
      fill="#4f2b1b"
    />
    <path
      d="m11.07 23.66c-.4-.69-.14-5.06 0-6.71.08-1.36.12-2.15.09-2.53a23.65 23.65 0 0 1 1-3.76c1-3.1 1.19-3.84.4-4.18-.07 0-.19-.08-.21-.48a5 5 0 0 1 2.46-.25h.13a2.71 2.71 0 0 1 2 .27 1.44 1.44 0 0 1 -.44.57l-.36.28 1.92 6.75c.33 3.25.63 8.82 0 9.94-.36.64-1.09.68-2.34.69-.38 0-.78 0-1.19 0a5.53 5.53 0 0 1 -3.46-.59z"
      fill="#fff"
    />
    <path
      d="m19.41 13.4-1.71-6.07a1.93 1.93 0 0 0 .59-1.61c-.22-1-1.66-1.59-3.5-1.35-1-.06-2.72 0-3.48.66a1.19 1.19 0 0 0 -.39.87 1.94 1.94 0 0 0 .66 1.62c-.11.56-.49 1.81-.78 2.73a16.48 16.48 0 0 0 -1 4.29c0 .3 0 1.28-.1 2.32-.3 5-.3 7.22.53 7.86a6.07 6.07 0 0 0 3.59 1 8.25 8.25 0 0 0 .86 0h1.1c1.35 0 2.76 0 3.52-1.39 1.01-1.98.21-10.01.11-10.93zm-8.34 10.26c-.4-.69-.13-5.06 0-6.71a23 23 0 0 0 .09-2.53 22.85 22.85 0 0 1 1-3.76c1-3.11 1.18-3.84.4-4.18-.08 0-.2-.08-.22-.48a5 5 0 0 1 2.46-.25h.14a2.67 2.67 0 0 1 2 .27 1.5 1.5 0 0 1 -.45.57l-.35.28 1.91 6.75c.34 3.25.64 8.82 0 9.94-.36.64-1.08.68-2.34.69-.38 0-.78 0-1.19 0a5.53 5.53 0 0 1 -3.45-.59z"
      fill="#4f2b1b"
    />
  </svg>
</template>
